/**
 * Axios/fetch 配置：仅在存在具体 project 时附加 X-Project-Id（'all' 不发送头）
 */
export function xProjectIdConfig(
  projectId?: string | number | null
): { headers: { 'X-Project-Id': string } } | undefined {
  if (projectId === undefined || projectId === null) return undefined;
  const s = String(projectId).trim();
  if (!s || s === 'all') return undefined;
  return { headers: { 'X-Project-Id': s } };
}

/**
 * 与 ModelingManager 一致：从 localStorage.user.tenants 取当前租户 id，供转发 ChatBI 的 X-Tenant-Id
 */
export function getCurrentTenantIdForRemoteApi(): string {
  const currentTenantCode = localStorage.getItem('currentTenant') || 'default';
  try {
    const rawUser = localStorage.getItem('user');
    if (!rawUser) return currentTenantCode;
    const obj = JSON.parse(rawUser);
    const tenants = obj?.tenants;
    if (Array.isArray(tenants)) {
      const match = tenants.find(
        (t: { code?: string; tenant_code?: string }) =>
          t?.code === currentTenantCode || t?.tenant_code === currentTenantCode
      );
      const id = match?.id ?? obj?.tenant_id ?? obj?.tenantId;
      if (id !== undefined && id !== null) return String(id);
    }
    const fallbackId = obj?.tenant_id ?? obj?.tenantId;
    return fallbackId !== undefined && fallbackId !== null ? String(fallbackId) : currentTenantCode;
  } catch {
    return currentTenantCode;
  }
}

/** Agent 权限发布/恢复/备份：同时带 X-Project-Id（可选）与 X-Tenant-Id */
export function agentChatBIRequestConfig(
  projectId?: string | number | null
): { headers: Record<string, string> } | undefined {
  const headers: Record<string, string> = {};
  const tid = getCurrentTenantIdForRemoteApi().trim();
  if (tid) headers['X-Tenant-Id'] = tid;
  const proj = xProjectIdConfig(projectId);
  if (proj?.headers['X-Project-Id']) {
    headers['X-Project-Id'] = proj.headers['X-Project-Id'];
  }
  return Object.keys(headers).length ? { headers } : undefined;
}
